import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';

import './CommonDropzone.scss';

function CommonDropzone({ className, style: customStyle = {}, onDrop, disabled, dropzoneProps = {}, children }) {
  const handleDrop = (acceptedFiles, ...rest) => {
    if (onDrop && !disabled) {
      onDrop(acceptedFiles, { ...rest });
    }
  };

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } = useDropzone({
    accept: { 'image/*': [] },
    onDrop: handleDrop,
    disabled,
    ...dropzoneProps,
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragAccept, isDragReject],
  );

  return (
    <div
      className={clsx('common-dropzone', className, disabled && 'common-dropzone--disabled')}
      style={{ ...customStyle }}>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        {children({ isFocused, isDragAccept, isDragReject })}
      </div>
    </div>
  );
}

export default CommonDropzone;

const baseStyle = {
  width: '100%',
  height: '100%',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  padding: '0.5rem',

  borderWidth: 2,
  borderRadius: 8,
  borderColor: 'var(--input-border)',
  borderStyle: 'dashed',

  backgroundColor: 'transparent',
  color: 'var(--input-placeholder)',
  outline: 'none',
  transition: 'border .3s ease-in-out',
};

const acceptStyle = {
  borderColor: 'var(--color-primary)',
};

const rejectStyle = {
  borderColor: 'var(--color-failure)',
};
